module.exports = __webpack_public_path__ + "static/rewards-card-banner-del-8e74804052219396b42d06fcd4c70ec0.png";